import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  min-height: 100%;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
`
export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0;
  z-index: 1;
  flex-basis: auto;
`

export const Wrapper = styled.div`
  align-items: stretch;
  width: 100%;
  max-width: 320px;
  padding: 40px 0;

  ${media.xs`
    max-width: 280px;
  `}

  ${media.sm`
    max-width: 425px;
  `}
`
